// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-termination-data-return-confirmation.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-termination-data-return-confirmation',
  title: 'Obtain written confirmation of customer data return at contract termination',
  description:
    'Upon termination or change of an employment or contract relationship, employees who have worked on a government framework contract must provide written confirmation that all copies of customer-owned data — including information stored on personally-owned devices — have been returned or securely destroyed.',
  category: 'people',
  scfIds: ['SCF-PPL-005', 'SCF-DAT-001'],
  cadence: { frequency: 'once', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Termination data-return confirmation procedure is documented',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
